import {isCopilot} from '@github-ui/assignees/copilot-user'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'

const COPILOT_REVIEWER_SLUG = 'copilot-pull-request-reviewer'

export function isCopilotPullRequestReviewer(reviewer: Pick<Reviewer, 'displayLogin' | 'slug'> | undefined): boolean {
  if (!reviewer) return false

  const slug = normalizeReviewerSlug(reviewer.slug)
  if (slug) return slug === COPILOT_REVIEWER_SLUG

  return reviewer.displayLogin.toLowerCase() === 'copilot'
}

export function isCopilotReviewer(reviewer: Pick<Reviewer, 'displayLogin' | 'slug'> | undefined): boolean {
  return isCopilotPullRequestReviewer(reviewer) || isCopilot(reviewer?.displayLogin ?? '')
}

export function normalizeReviewerSlug(slug: string | null | undefined): string {
  return (slug ?? '').replace(/\[bot\]$/, '')
}
